import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { AgGridI } from '../../../../../../shared/components/ag-grid/ag-grid.model';
import { AgGridComponent } from '../../../../../../shared/components/ag-grid/ag-grid.component';
import { AgGridDataModelSendRequest } from '../../../part-list.model';
import { PaginationModel } from '../../../../../../shared/model/pagination.model';
import { AgGridService } from '../../../../../../shared/components/ag-grid/ag-grid.service';

@Component({
  selector: 'app-send-request-tab',
  templateUrl: './send-request-tab.component.html',
  styleUrls: ['./send-request-tab.component.scss']
})
export class SendRequestTabComponent implements OnInit {
  AgGridDataModel: AgGridI;
  gridApiForDataModel: any
  @ViewChildren(AgGridComponent) grids: QueryList<AgGridComponent>
  @Input()  data:any ={}
  paginationModel : any = {};

  constructor(public agGridService: AgGridService) { }

  ngOnInit(): void {
    this.AgGridDataModel = AgGridDataModelSendRequest;
  }
     onPagination(pagination: PaginationModel) {
    this.paginationModel.pageNumber = pagination?.pageNumber;
    this.paginationModel.pageSize = pagination?.pageSize;
    this.paginationModel.getAll = pagination?.getAll;
    this.paginate();
  }

    getRowStyle = (params: any) => {
      return { borderBottom: '1px solid #E9EDF2' };
    };
    
    onSelectionChange(params) {
      // let data = params?.api?.getSelectedRows();
      // this.selectedData = [...data]
    }
    onGridReady(event) {
      this.gridApiForDataModel = event;
  }
    triggerGridReady() {
    this.paginate() 
      const confirmedIds = new Set(this.data?.confirmedData?.map(item => item.id));
    this.gridApiForDataModel?.api?.deselectAll();
    this.gridApiForDataModel?.api?.forEachNode(node => {
     if (confirmedIds.has(node.data?.id)) {
        node.setSelected(true);
      }
    });
  this.agGridService.toggleHeaderCheckedValue.next({params:null,value:true})
  this.agGridService.toggleCheckboxIcon.next({params:{disable:true},value:true});
  }
 paginate() {
     let  gridRef = this.grids?.first;
    const startIndex = (this.paginationModel?.pageNumber - 1) * this.paginationModel?.pageSize;
    const endIndex = startIndex + this.paginationModel?.pageSize;
    this.data.paginatedItems = this.data?.confirmedData?.slice(startIndex, endIndex);
    this.gridApiForDataModel?.api?.setRowData(this.paginationModel.getAll?this.data?.confirmedData:this.data?.paginatedItems??[]);
    gridRef.updatePaginationData(this.paginationModel, this.data?.confirmedData?.length??0);
  }
}
